<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="toggleMessages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CALENDAR_EVENTS_PAGE_ATTR_NAME = 'calendar-facet-event-page-url';

export default {
    name: 'calendar-facet-event-page-url',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Use specific event page',
            value: {},
            message: 'When a date is clicked the Link Builder value will be used for the page to redirect the user to. If empty, the user will stay on the same page.',
            toggleMessages: {
                checked: 'On',
                unchecked: 'Off',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (!isChecked) {
                this.selectedElements.forEach((elem) => {
                    elem.isLinkNew = isChecked;
                    if (!isChecked) {
                        elem.clearLink();
                    }
                });
            }
            this.selectedElements[0].isEventPage = isChecked;
            this.selectedElements[0].setElementData(CALENDAR_EVENTS_PAGE_ATTR_NAME, isChecked);
            this.checked = isChecked;
            this.onOptionChange(isChecked);
            this.setChangedData(true);
        },

        onSelectedElement() {
            this.checked = this.selectedElements[0].getElementData(CALENDAR_EVENTS_PAGE_ATTR_NAME);
        },
    },
};
</script>
